var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.5 18a1.5 1.5 0 010 3h-21a1.5 1.5 0 010-3h21zm0-9a1.5 1.5 0 010 3h-21a1.5 1.5 0 010-3h21zm0-9a1.5 1.5 0 010 3h-21a1.5 1.5 0 010-3h21z","fillRule":"evenodd"}));
}

Hamburger.defaultProps = {"width":"24","height":"21"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
